import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

import { PatientService } from '../../patient/patient.service';
import { PatientPortalService } from '../patient-portal.service';
import { FileManagerUploadComponent } from '../../file-manager/file-manager-upload/file-manager-upload.component';
import { CommMethodEnum } from '../../../models/enum/comm-method.enum';
import { Router } from '@angular/router';
import { CommLocationEnum } from 'src/app/models/enum/comm-location.enum';
import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';
import { StaticDataService } from 'src/app/services/static-data.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-patient-portal-my-info',
  templateUrl: './patient-portal-my-info.component.html',
  styleUrls: ['./patient-portal-my-info.component.css']
})
export class PatientPortalMyInfoComponent implements OnInit {

  isLoading: boolean = false;

  selectedTab: number = 1;
  PatientId: string;
  Patient: any;
  PatientContact: any;
  PatientAddress: any;
  imageViewWidth: number = 0;

  PatientContactMethodPhone: any;
  PatientContactMethodEmail: any;

  enumSalutations: any[] = [];
  enumSuffixes: any[] = [];
  enumGenders: any[] = [];
  enumContactMethods: any[] = [];

  enumSalutationName: string = 'enumSalutation';
  enumSuffixName: string = 'enumNameSuffix';
  enumGenderName: string = 'enumGender';
  enumContactMethod = 'enumCommMethod';
  enumState = 'enumStateProvince';

  enumHomeAddressType = '00000008-1000-0000-0000-000000000001';

  stateListEnums: EnumValidValueItemModel[] = [];

  isTabletPortrait = false;
  isTabletLandscape = false;
  isHandsetPortrait = false;
  isFullScreen = false;

  @ViewChild('imageView') imageView: any;
  @ViewChild('contactView') contactView: any;
  @ViewChild('insuranceView') insuranceView: any;


  constructor(private router: Router,
    private patientService: PatientService,
    //private patientPortalService: PatientPortalService, 
    private patientPortalService: PatientPortalService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private staticDataService: StaticDataService,
    private responsive: BreakpointObserver
  ) {
    const localStorageData = JSON.parse(localStorage.getItem('storedPatient'));
    this.PatientId = localStorageData.authdata.patientid;
  }

  ngOnInit() {

    this.responsive.observe([
      Breakpoints.TabletPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait,
      Breakpoints.TabletLandscape])
      .subscribe(result => {

        this.isFullScreen = false;
        this.isHandsetPortrait = false;
        this.isTabletPortrait = false
        this.isTabletLandscape = false;

        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.TabletPortrait]) {
          this.isTabletPortrait = true;
        }
        else if (breakpoints[Breakpoints.HandsetLandscape]) {
          this.isHandsetPortrait = true;
        }
        else if (breakpoints[Breakpoints.HandsetPortrait]) {
          this.isHandsetPortrait = true;

        }
        else if (breakpoints[Breakpoints.TabletLandscape]) {
          this.isTabletLandscape = true;
        }
        else {
          this.isFullScreen = true;
        }

      });

    if (!this.staticDataService.isReady) {
      this.isLoading = true;
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.init();
        }
      });
    } else {
      this.init();
    }
  }

  onStateChange(event: EnumValidValueItemModel) {
    const model = this.stateListEnums.find(p => p.ValidValueItemId.toLowerCase() === event.ValidValueItemId.toLowerCase());
    if (model) {
      this.PatientAddress.State = model.ItemSValue;
      this.PatientAddress.enumStateProvinceID = model.ValidValueItemId;
    }
  }
  moveSelectedTab(inc) {
    if (inc) {
      if (this.selectedTab >= 3) {
        this.selectedTab = 1;
      } else {
        this.selectedTab++;
      }
    } else {
      if (this.selectedTab <= 1) {
        this.selectedTab = 3;
      } else {
        this.selectedTab--;
      }
    }
  }

  getFileViewWidth() {
    try {
      const imageViewSize = document.getElementById('myInfoMainContainer').offsetWidth;
      return imageViewSize;
    } catch (err) {
      console.log('ERROR', err);
      return 0;
    }
  }

  displayMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  init() {

     const promises = [
       this.getPatientInformation(),
    //   this.getEnumByName(this.enumSalutationName),
    //   this.getEnumByName(this.enumSuffixName),
    //   this.getEnumByName(this.enumContactMethod),
    //   this.getEnumByName(this.enumContactMethod),
    //   this.getEnumByName(this.enumState),
     ];

    this.isLoading = true;
    this.enumSalutations = this.staticDataService.getValidValueItemsByValidValueName(this.enumSalutationName);
    this.enumSuffixes = this.staticDataService.getValidValueItemsByValidValueName(this.enumSuffixName);
    this.enumGenders = this.staticDataService.getValidValueItemsByValidValueName(this.enumGenderName);
    this.enumContactMethods = this.staticDataService.getValidValueItemsByValidValueName(this.enumContactMethod);
    this.stateListEnums = this.staticDataService.getValidValueItemsByValidValueName(this.enumState);


     Promise.all(promises).then((results: any[]) => {

    // this.enumSalutations = results[1];
    // this.enumSuffixes = results[2];
    // this.enumContactMethods = results[3];
    // this.stateListEnums = results[4];

    this.Patient = results[0].ThePatient;
    this.PatientContact = JSON.parse(JSON.stringify(this.Patient.dataContact));

    const addressArray = JSON.parse(JSON.stringify(this.PatientContact.dataAddresses));
    const communicationArray = JSON.parse(JSON.stringify(this.PatientContact.dataContactComms));

    const createPromises = [];
    let createAddress: boolean = false;
    let createContactMethodPhone: boolean = true;
    let createContactMethodEmail: boolean = true;

    if (addressArray.length === 0) {
      createAddress = true;
      createPromises.push(this.createAddress(this.PatientContact.ContactId));
    } else {
      let address = addressArray[0];
      addressArray.forEach(dataAddress => {
        if (dataAddress.enumAddressCategoryID === this.enumHomeAddressType) {
          address = dataAddress;
        }
      });
      this.PatientAddress = JSON.parse(JSON.stringify(address));
    }

    if (communicationArray.length !== 0) {

      let communicationMethodPhone;
      let communicationMethodEmail;

      communicationArray.forEach(dataCommunication => {

        if (dataCommunication.enumCommMethodID?.toLowerCase() === CommMethodEnum.Mobile.toLowerCase() && dataCommunication.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase()) {
          communicationMethodPhone = dataCommunication;
          createContactMethodPhone = false;
        }

        if (dataCommunication.enumCommMethodID?.toLowerCase() === CommMethodEnum.Phone.toLowerCase() && dataCommunication.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase() && createContactMethodPhone) {
          communicationMethodPhone = dataCommunication;
          createContactMethodPhone = false;
        }

        if (dataCommunication.enumCommMethodID?.toLowerCase() == CommMethodEnum.Email.toLowerCase() && dataCommunication.enumCommLocationID?.toLowerCase() == CommLocationEnum.HOME.toLowerCase()) {
          communicationMethodEmail = dataCommunication;
          createContactMethodEmail = false;
        }

      });

      if (communicationMethodPhone) {
        this.PatientContactMethodPhone = JSON.parse(JSON.stringify(communicationMethodPhone));
      } else {
        createPromises.push(this.createContactMethod(CommLocationEnum.HOME, CommMethodEnum.Mobile));
      }

      if (communicationMethodEmail) {
        this.PatientContactMethodEmail = JSON.parse(JSON.stringify(communicationMethodEmail));
      } else {
        createPromises.push(this.createContactMethod(CommLocationEnum.HOME, CommMethodEnum.Email));
      }

    } else {
      createPromises.push(this.createContactMethod(CommLocationEnum.HOME, CommMethodEnum.Mobile));
      createPromises.push(this.createContactMethod(CommLocationEnum.HOME, CommMethodEnum.Email));
    }

    if (createPromises.length) {

      Promise.all(createPromises).then((createResults: any[]) => {

        let index = 0;
        if (createAddress) {
          this.PatientAddress = createResults[index];
          index++;
        }

        if (createContactMethodPhone) {
          this.PatientContactMethodPhone = createResults[index];
          index++;
        }

        if (createContactMethodEmail) {
          this.PatientContactMethodEmail = createResults[index];
          index++;
        }

        this.isLoading = false;

      }, err => {
        console.log(err);
        this.isLoading = false;
        this.displayMessage('Error', 'Something went wrong');
      });
    } else {
      this.isLoading = false;
    }

  }, err => {
  console.log(err);
  this.isLoading = false;
  this.displayMessage('Error', 'Something went wrong');
});
  }

activateImageView() {
  console.log(this.imageView);
  this.imageView.handleUploadClicked();
}

getEnumByName(enumName: string) {
  const promise = new Promise((resolve, reject) => {
    this.patientPortalService.getValidValueByName(enumName)
      .subscribe(resolve, reject);
  });
  return promise;
}

createAddress(contactID: string) {
  const promise = new Promise((resolve, reject) => {
    this.patientService.getNewContactAddress(contactID)
      .subscribe(resolve, reject);
  });
  return promise;
}

createContactMethod(location: string, type: string) {
  const promise = new Promise((resolve, reject) => {
    this.patientService.getNewComm(this.PatientId)
      .subscribe(response => {
        response.enumCommMethodID = type;
        response.enumCommLocationID = location;        
        resolve(response);
      }, reject);
  });
  return promise;
}

getPatientInformation() {
  const promise = new Promise((resolve, reject) => {
    //      this.patientService.getPatient(this.PatientId)
    this.patientPortalService.getPatientInfo(this.PatientId)
      .subscribe(resolve, reject);
  });
  return promise;
}

saveAllWindows() {

  this.isLoading = true;

  this.Patient.BirthDate = this.PatientContact.BirthDate;
  const patientClone = JSON.parse(JSON.stringify(this.Patient));
  patientClone.dataContact = null;
  patientClone.dataPatientContacts = [];

  const contactClone = JSON.parse(JSON.stringify(this.PatientContact));
  contactClone.dataAddresses = [];
  contactClone.dataContactComms = [];

  const addressClone = JSON.parse(JSON.stringify(this.PatientAddress));
  contactClone.dataAddresses.add(addressClone);
  const phoneClone = JSON.parse(JSON.stringify(this.PatientContactMethodPhone));  
  const emailClone = JSON.parse(JSON.stringify(this.PatientContactMethodEmail));
  phoneClone.IsPreferred=true;
  emailClone.IsPreferred=true;
  contactClone.dataContactComms.add(phoneClone);
  contactClone.dataContactComms.add(emailClone);
  const promises = [
    this.saveDataPatient(patientClone),
    this.saveDataContact(contactClone),
    this.insuranceView.saveFromAllWindows(),
    this.contactView.saveFromAllWindows(),
  ];

  Promise.all(promises).then((results: any[]) => {
    this.init();
  }, err => {
    console.log(err);
    this.isLoading = false;
    this.displayMessage('Error', 'Something went wrong');
  });
}

saveDataPatient(dataPatient) {
  const promise = new Promise((resolve, reject) => {
    this.patientService.saveDataPatient(dataPatient)
      .subscribe(resolve, reject);
  });
  return promise;
}

savePatientDetails() {

  this.isLoading = true;

  const patientClone = JSON.parse(JSON.stringify(this.Patient));
  patientClone.dataContact = null;
  patientClone.dataPatientContacts = [];

  const contactClone = JSON.parse(JSON.stringify(this.PatientContact));
  contactClone.dataAddresses = [];
  contactClone.dataContactComms = [];

  const addressClone = JSON.parse(JSON.stringify(this.PatientAddress));
  const phoneClone = JSON.parse(JSON.stringify(this.PatientContactMethodPhone));
  const emailClone = JSON.parse(JSON.stringify(this.PatientContactMethodEmail));

  const promises = [
    this.saveDataPatient(patientClone),
    this.saveDataContact(contactClone),
    this.saveAddressDetails(addressClone),
    this.saveCommunicationDetails(phoneClone),
    this.saveCommunicationDetails(emailClone),
  ];

  Promise.all(promises).then((results: any[]) => {
    this.init();
  }, err => {
    console.log(err);
    this.isLoading = false;
    this.displayMessage('Error', 'Something went wrong');
  });

}

saveDataContact(dataContact) {
  const promise = new Promise((resolve, reject) => {
    this.patientService.saveDataContact(this.PatientId, dataContact)
      .subscribe(resolve, reject);
  });
  return promise;
}

saveAddressDetails(addressObj: any) {
  const promise = new Promise((resolve, reject) => {
    this.patientService.saveContactAddress(addressObj)
      .subscribe(resolve, reject);
  });
  return promise;
}

saveCommunicationDetails(communicationObj: any) {
  const promise = new Promise((resolve, reject) => {
    this.patientService.saveContactMethod(communicationObj)
      .subscribe(resolve, reject);
  });
  return promise;
}

handleTabChange(event) {
  if (event.index == 0)
    this.router.navigateByUrl('/patientportal/home');
  else if (this.selectedTab != event.index) {
    this.selectedTab = event.index;
  }
}

openImageUploader() {
  const tmp: any = {
    PatientId: this.PatientId,
    LOCID: 0,
    // WorkItemEventId: this.WorkItemEventId,
    Description: 'Info Grabber Upload',
    // DocumentFileName: this.DocumentFileName,
    // enumDocumentFileTypeID: this.enumDocumentFileTypeID,
    // enumDocumentTypeID: this.enumDocumentTypeID,
    // DocumentOrder: this.DocumentOrder,
    // ParentDocumentID: this.ParentDocumentID,
    // ImageSpreadPKID: this.ImageSpreadPKID,
    // enumDocumentTags: this.enumDocumentTags.join('|'),
    // DocumentGroupId: this.DocumentGroupId,
  };

  const data = {};

  for (const i in tmp) {
    if (tmp[i]) {
      data[i] = tmp[i];
    }
  }

  const dialogRef = this.dialog.open(FileManagerUploadComponent, {
    height: '75%',
    width: '90%',
    maxHeight: '800px',
    maxWidth: '800px',
    data
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log(result);
  }, err => {
    console.log('err');
  });
}

}
